import { MenuItem } from "@mui/material"
import { ReactElement } from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { Order } from "../../../../../merchant/controlKitchenTypes"

type MenuActionKey = "showReceipt"

type MenuItemConfig = {
    key: MenuActionKey
    element: ReactElement
}

type UserDailyPurchasesMenuProps = {
    order: Order
    onShowReceipt: (order: Order) => void
    onClose: () => void
}

export function UserDailyPurchasesMenu({ order, onShowReceipt, onClose }: UserDailyPurchasesMenuProps) {
    const handleShowReceipt = () => {
        onShowReceipt(order)
        onClose()
    }

    const menuItemsConfig: MenuItemConfig[] = [
        {
            key: "showReceipt",
            element: (
                <LocalizedStrict id="office-purchase-receipt" key={`receipt-${order.id}`}>
                    <MenuItem onClick={handleShowReceipt}>Receipt</MenuItem>
                </LocalizedStrict>
            ),
        },
    ]

    // as we don't have orderAction for now - we just return the menu items elements
    const menuItems = menuItemsConfig.map((item) => item.element)

    return <>{menuItems}</>
}

